// src/components/CustomHistoryRouter.tsx
import React, { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import type { BrowserHistory } from 'history';

interface Props {
    history: BrowserHistory;
    basename?: string;
    children: React.ReactNode;
}

export const CustomHistoryRouter: React.FC<Props> = ({ history, basename, children }) => {
    const [state, setState] = useState({
        action: history.action,
        location: history.location
    });

    useLayoutEffect(() => {
        return history.listen(setState);
    }, [history]);

    return (
        <Router
            basename={basename}
            location={state.location}
            navigationType={state.action}
            navigator={history}
        >
            {children}
        </Router>
    );
};
